export default __webpack_public_path__ + "static/media/desk.4975a276.png";